import pathOr from 'ramda/src/pathOr';

import ErrorType from '../../Errors/Constants/Error.type';
import deriveConvivaCustomMetadata from './deriveConvivaCustomMetadata';

/**
 * @param  {[Playback, ResumePoints, Config, Asset]} loadData
 * @param  {[Manifest]} manifest
 */

const extractLoadData = (loadData, manifest) => {
    const [
        latestPlayback,
        { resumeFrom },
        latestConfig,
        latestAsset,
    ] = loadData;

    const { mediaType, licenseUrl, releasePid } = latestPlayback;
    const { authToken, viewerId } = latestConfig.environment;
    const { tileImageUrl } = latestAsset;

    const enableClosedCaptions = pathOr(false, ['dazn', 'startupData', 'FeatureToggles', 'ClosedCaptionsV1'], window);

    const convivaCustomMetaData = deriveConvivaCustomMetadata(
        latestPlayback,
        latestConfig,
        latestAsset,
        window
    );

    return ({
        mediaType,
        licenseUrl,
        releasePid,
        manifestUrl: manifest.url,
        authToken,
        tileImageUrl,
        resumeFrom,
        title: `[${latestPlayback.asset.id}] ${latestPlayback.asset.title}`,
        convivaCustomMetaData,
        viewerId,
        enableClosedCaptions,
    });
};

const mapResumeFromToCurrentTime = (getErrorType, player, data) => {
    if (getErrorType() === ErrorType.PLAYBACK_SOURCE_MIDSTREAM) {
        data.resumeFrom = player.state.snapshot.playback.currentTime;
    }
    return data;
};

export {
    extractLoadData,
    mapResumeFromToCurrentTime,
};
